// extracted by mini-css-extract-plugin
export var root = "MainNav-module--root--3kHgQ";
export var main = "MainNav-module--main--2Pt4S";
export var brand = "MainNav-module--brand--1Py1x";
export var btn = "MainNav-module--btn--Y5evd";
export var drop = "MainNav-module--drop--2A_aR";
export var toggle = "MainNav-module--toggle--2OSx_";